import { type Condition } from '@repo/api-gw-sdk';

import { useDAL } from '@/contexts/useDAL';
import { createCombineCondition } from '@/types/advanceFilter';
import { convertQuery } from '@/utils/conditionQuery';

/**
 * Every caller of this hook renders the whole set — pickers, dialogs and the role limit editors —
 * and none of them pages. Sending no page size leaves the endpoint on its 50-record default, which
 * drops the rest of the accounts with nothing to say it happened: a picker just never offers them.
 * Callers that do page use usePaginatedRestoreAccounts instead.
 */
const ALL_RESTORE_ACCOUNTS_PAGE_SIZE = 10000;

export const useRestoreAccounts = (condition?: Condition, enabled = true) => {
  const dal = useDAL();
  return dal.cloudAccounts.restore.useList(
    0,
    ALL_RESTORE_ACCOUNTS_PAGE_SIZE,
    condition
      ? { filters: convertQuery(createCombineCondition([condition])) }
      : {},
    enabled
  );
};
